/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Модель для дополнительного телефона пользователя
   */
  app.UserPhone = app.Model.extend({
    defaults: {
      value: ''
    },
    /**
     * Метод находит подходящую номеру телефона маску и подставляет её
     * Возвращает телефон в виде строки в привычном для человека формате
     * @returns {String} отформатированный номер телефона
     */
    phoneHumanFormat: function () {
      return app.helpers.PhoneHelper.getFormatedPhoneNumber(this.get('value'));
    }
  });
})();

}.call(window));